/* unplugin-vue-components disabled */import { render } from "./login2.vue?vue&type=template&id=86e63a12"
import script from "./login2.vue?vue&type=script&lang=js"
export * from "./login2.vue?vue&type=script&lang=js"

import "./login2.vue?vue&type=style&index=0&id=86e63a12&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__